var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',{key:_vm.key,ref:"toastuiEditor",attrs:{"initialValue":_vm.text,"options":_vm.editorOptions,"height":"auto","initialEditType":"wysiwyg"},on:{"change":function($event){return _vm.onChange()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }